import React from 'react';
import PropTypes from 'prop-types';
import Brand from './Brand';
import Banner from './Banner';
import OrganizationList from './OrganizationList';

/**
 * Metronic header layout
 */
export default function Header({ theme, organizationId, authOrganizations }) {
  return (
    <header id="m_header" className="m-grid__item m-header">
      <div className="m-header__top header-top">
        <div className="m-container m-container--responsive m-container--xxl m-container--full-height m-page__container">
          <div className="m-stack m-stack--ver m-stack--desktop">
            <Brand theme={theme} />
            <Banner />
            <OrganizationList
              organizationId={organizationId}
              authOrganizations={authOrganizations}
            />
          </div>
        </div>
      </div>
    </header>
  );
}

Header.propTypes = {
  /** metronic theme in use */
  theme: PropTypes.string.isRequired,
  /** member currently logged in */
  organizationId: PropTypes.string,
  authOrganizations: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
};

Header.defaultProps = {
  organizationId: null,
  authOrganizations: [],
};
